import script from "./InvoiceItems.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceItems.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceItems.vue?vue&type=style&index=0&id=3233cd4c&scoped=true&lang=css"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3233cd4c"]])

export default __exports__